import React, { Component } from 'react'
import { connect } from 'react-redux'
import './_styles.scss'
import Submenu from '../Partidos/Components/SubmenuFases'
import CountryCard from './components/CountryCard'
import EmptyFavorites from './components/EmptyFavorites'
import Device from '../../../devices/device'

import { pushNavHistory, restoreComplete } from '../store/actions'
import { getCountries } from '../services/getCountries'
import Utils from '../../../utils/Utils'
import { getNodeCode, sendMetricScroll, sendMetricSelectContent } from '../utils'
import Translator from '../../../requests/apa/Translator'
import { countriesTabs } from './constants'
import { getCountriesTabs } from './utils'
import { MAIN_MENU } from '../constants'

class Countries extends Component {

    constructor (props) {
        super(props);
        this.state = {
            activeLetterFilter: Translator.get('eventodeportivo_paises_tabs_texto_tab1'),
            activeCategoryTab: Translator.get('eventodeportivo_paises_tabs_texto_tab1'),
            visibleLetterTabs: [],
            filteredCountries: [],
            allCountries: [],
            letterTabs: [],
            letterFilterPerTab: {}  // recuerda el filtro activo de cada tab independientemente
        }
        this.tabsFirstLevel = getCountriesTabs()   
        this.idTabFavoritos = Translator.get('eventodeportivo_paises_tabs_texto_tab2')
        this.containerRef = null
        this.categoryNavRef = null
        this.letterNavRef = null
        this.keys = Device.getDevice().getKeys()
        this.cardScrollMilestonesSent = new Set()

        const code = getNodeCode()
        const metadataValue = Utils.getApaMetadataKey('sports_competition_config', null)
        this.idLeague = metadataValue && metadataValue[code] ? metadataValue[code].leagueId : null
    }

    async componentDidMount() {
        const { activeCategoryTab, activeLetterFilter } = this.state
        const { pendingRestore, sectionId } = this.props
        const restoreEntry = pendingRestore && pendingRestore.section === sectionId
            ? pendingRestore
            : null

        const { countries, tabs } = await getCountries(this.idLeague);

        if (restoreEntry) {
            this.setState({ allCountries: countries, letterTabs: tabs }, () => {
                this.applyRestore(restoreEntry)
            })
        } else {
            this.setState({ allCountries: countries, visibleLetterTabs: tabs, letterTabs: tabs }, () => {
                this.fetchFilterCountries(activeLetterFilter)
            })
        }

        if (this.containerRef) {
            this.containerRef.addEventListener('keydown', this.handleGridKeyDown, true)
        }

        // Métricas
        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTabLabel = this.state.activeCategoryTab
        const childTabData = this.state.visibleLetterTabs.find(letter => letter.id === this.state.activeLetterFilter)
        const childTabLabel = childTabData && childTabData.label
        sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
        localStorage.removeItem('lastFocusRecordPartido');
    }

    componentWillUnmount() {
        localStorage.removeItem('lastFocusPais');
        if (this.containerRef) {
            this.containerRef.removeEventListener('keydown', this.handleGridKeyDown, true)
        }
        // Si pendingRestore está activo, el desmontaje fue causado por un BACK
        // a otra sección → no empujar al historial para evitar el loop
        if (this.props.pendingRestore) return

        const { activeLetterFilter, activeCategoryTab, letterFilterPerTab } = this.state
        this.props.pushNavHistory({
            section: this.props.sectionId,
            activeLetterFilter,
            activeCategoryTab,
            letterFilterPerTab
        })
    }

    componentDidUpdate(prevProps) {
        const { pendingRestore, sectionId } = this.props
        if (
            pendingRestore &&
            pendingRestore !== prevProps.pendingRestore &&
            pendingRestore.section === sectionId
        ) {
            this.applyRestore(pendingRestore)
        }
    }

    getScrollMetricContext = () => {
        const { activeCategoryTab, activeLetterFilter, visibleLetterTabs } = this.state
        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTab = this.tabsFirstLevel.find(tab => tab.id === activeCategoryTab)
        const parentTabLabel = parentTab && parentTab.label
        const childTab = visibleLetterTabs.find(tab => tab.id === activeLetterFilter)
        const childTabLabel = activeCategoryTab === this.idTabFavoritos ? null : childTab && childTab.label
        return { mainMenuLabel, parentTabLabel, childTabLabel }
    }

    trackCardContainerScrollMilestones = (currentKey, previousScrollTop, currentScrollTop, maxScrollTop, isAtNavigationEnd) => {
        if (currentKey !== 'UP' && currentKey !== 'DOWN') return
        if (maxScrollTop <= 0) return

        const prevPercent = Math.round(previousScrollTop / maxScrollTop * 100)
        const nextPercent = Math.round(currentScrollTop / maxScrollTop * 100)
        const { mainMenuLabel, parentTabLabel, childTabLabel } = this.getScrollMetricContext()

        if (currentKey === 'DOWN') {
            const MILESTONES = [25, 50, 75]
            MILESTONES.forEach(m => {
                if (prevPercent < m && m <= nextPercent && !this.cardScrollMilestonesSent.has(m)) {
                    this.cardScrollMilestonesSent.add(m)
                    sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
                }
            })
            if ((currentScrollTop >= maxScrollTop || isAtNavigationEnd) && !this.cardScrollMilestonesSent.has(100)) {
                this.cardScrollMilestonesSent.add(100)
                sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, 100)
            }
        } else {
            if (!isAtNavigationEnd && this.cardScrollMilestonesSent.has(100)) {
                this.cardScrollMilestonesSent.delete(100)
            }
            if (prevPercent === 100 && nextPercent < 100) {
                this.cardScrollMilestonesSent.delete(100)
            }
            const MILESTONES = [25, 50, 75]
            MILESTONES.forEach(m => {
                if (nextPercent < m && m <= prevPercent && this.cardScrollMilestonesSent.has(m)) {
                    this.cardScrollMilestonesSent.delete(m)
                    sendMetricScroll(mainMenuLabel, parentTabLabel, childTabLabel, m)
                }
            })
        }
    }

    applyRestore = (entry) => {
        const restoredTab        = entry.activeCategoryTab    || Translator.get('eventodeportivo_paises_tabs_texto_tab1')
        const restoredFilter     = entry.activeLetterFilter || Translator.get('eventodeportivo_paises_tabs_texto_tab1')
        const restoredFiltersPerTab = entry.letterFilterPerTab || {}

        this.setState({
            activeCategoryTab: restoredTab,
            activeLetterFilter: restoredFilter,
            letterFilterPerTab: restoredFiltersPerTab,
            visibleLetterTabs: restoredTab === this.idTabFavoritos ? [] : this.state.letterTabs
        }, () => {
            if (restoredTab === this.idTabFavoritos) {
                this.fetchFavoritesCountries(restoredTab)
                setTimeout(() => {
                    const btn = this.categoryNavRef && this.categoryNavRef.querySelector('.focusable')
                    btn && btn.focus()
                }, 0)
            } else {
                this.fetchFilterCountries(restoredFilter)
                setTimeout(() => {
                    const btn = this.letterNavRef && this.letterNavRef.querySelector('.focusable')
                    btn && btn.focus()
                }, 0)
            }
            this.props.restoreComplete()
        })
    }

    scrollCardIntoView = (card) => {
        const container = this.containerRef
        if (!container || !card) return

        const PADDING = 20 // px extra arriba/abajo para que no quede pegada al borde
        const cardTop = card.offsetTop
        const cardBottom = cardTop + card.offsetHeight
        const containerScrollTop = container.scrollTop
        const containerVisibleBottom = containerScrollTop + container.clientHeight

        if (cardTop - PADDING < containerScrollTop) {
            container.scrollTop = cardTop - PADDING
        } else if (cardBottom + PADDING > containerVisibleBottom) {
            container.scrollTop = cardBottom + PADDING - container.clientHeight
        }
    }

    handleGridKeyDown = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
        if (!['UP', 'DOWN', 'LEFT', 'RIGHT'].includes(currentKey)) return

        const container = this.containerRef
        const focused = document.activeElement
        if (!container || !container.contains(focused)) return
        const prevScrollTop = container.scrollTop
        const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight)

        const cards = Array.from(container.querySelectorAll('.pais-card'))
        const currentIndex = cards.indexOf(focused)
        if (currentIndex === -1) return

        const COLS = 3
        const isEndIndex = (index) => index + COLS >= cards.length

        if (currentKey === 'UP') {
            const targetIndex = currentIndex - COLS
            if (targetIndex >= 0) {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
                this.scrollCardIntoView(cards[targetIndex])
                this.trackCardContainerScrollMilestones(currentKey, prevScrollTop, container.scrollTop, maxScrollTop, isEndIndex(targetIndex))
                cards[targetIndex].focus()
            } else {
                // primera fila → siempre consumir y subir al nav correcto
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
                const { visibleLetterTabs } = this.state
                if (visibleLetterTabs && visibleLetterTabs.length > 0) {
                    const btn = this.letterNavRef && this.letterNavRef.querySelector('.focusable')
                    if (btn) btn.focus()
                } else {
                    const btn = this.categoryNavRef && this.categoryNavRef.querySelector('.focusable')
                    if (btn) btn.focus()
                }
            }
        }

        if (currentKey === 'DOWN') {
            const targetIndex = currentIndex + COLS
            if (targetIndex < cards.length) {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
                this.scrollCardIntoView(cards[targetIndex])
                this.trackCardContainerScrollMilestones(currentKey, prevScrollTop, container.scrollTop, maxScrollTop, isEndIndex(targetIndex))
                cards[targetIndex].focus()
            } else {
                this.trackCardContainerScrollMilestones(currentKey, prevScrollTop, container.scrollTop, maxScrollTop, true)
            }
        }

        if (currentKey === 'LEFT') {
            const isFirstInRow = currentIndex % COLS === 0
            if (isFirstInRow) {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
            }
        }

        if (currentKey === 'RIGHT') {
            const isLastInRow = currentIndex % COLS === COLS - 1 || currentIndex === cards.length - 1
            if (isLastInRow) {
                e.preventDefault()
                e.stopPropagation()
                e.stopImmediatePropagation()
            }
        }
    }

    fetchFilterCountries = (filter) => {
        this.cardScrollMilestonesSent = new Set()
        const { allCountries } = this.state
        if(filter === Translator.get('eventodeportivo_paises_tabs_texto_tab1') ) return this.setState({ filteredCountries: allCountries })
        const matching = allCountries.filter(pais => pais.name.toLowerCase().startsWith(filter.toLowerCase()))
        this.setState({ filteredCountries: matching })
    }

    fetchFavoritesCountries = (tabId) => {
        this.cardScrollMilestonesSent = new Set()
        const { allCountries } = this.state
        if(tabId !== this.idTabFavoritos) return this.setState({ filteredCountries: allCountries })
        const favoriteCountries = allCountries.filter(pais => pais.favorited)
        this.setState({ filteredCountries: favoriteCountries })
    }

    onChangeTab = (steps) => {
        const { activeCategoryTab, activeLetterFilter, letterFilterPerTab } = this.state
        const {tabsFirstLevel} = this
        const currentIndex = tabsFirstLevel.findIndex(item => item.id === activeCategoryTab)
        const newIndex = currentIndex + steps
        if (newIndex < 0 || newIndex >= tabsFirstLevel.length) return
        const newActiveTab = tabsFirstLevel[newIndex].id

        // Guarda el filtro actual de la tab que se abandona
        const savedFilters = { ...letterFilterPerTab, [activeCategoryTab]: activeLetterFilter }
        // Restaura el filtro de la nueva tab (o Translator.get('eventodeportivo_paises_tabs_texto_tab1') si nunca se visitó)
        const restoredFilter = savedFilters[newActiveTab] || Translator.get('eventodeportivo_paises_tabs_texto_tab1')

        this.props.pushNavHistory({
            section: this.props.sectionId,
            activeLetterFilter,
            activeCategoryTab,
            letterFilterPerTab
        })

        this.setState({
            activeCategoryTab: newActiveTab,
            activeLetterFilter: restoredFilter,
            visibleLetterTabs: newActiveTab === this.idTabFavoritos ? [] : this.state.letterTabs,
            letterFilterPerTab: savedFilters
        }, () => {
            if (newActiveTab === this.idTabFavoritos) {
                this.fetchFavoritesCountries(newActiveTab)
            } else {
                this.fetchFilterCountries(restoredFilter)
            }
        })

        // Métricas
        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTabLabel = newActiveTab
        const childTabData = this.state.letterTabs.find(letter => letter.id === restoredFilter)
        const childTabLabel = newActiveTab === this.idTabFavoritos ? null : childTabData && childTabData.label
        sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
    }

    onChangeFilter = (steps) => {
        const { activeLetterFilter, activeCategoryTab, visibleLetterTabs, letterFilterPerTab } = this.state
        const currentIndex = visibleLetterTabs.findIndex(item => item.id === activeLetterFilter)
        const newIndex = currentIndex + steps
        if (newIndex < 0 || newIndex >= visibleLetterTabs.length) return

        const itemSelected = visibleLetterTabs[newIndex]
        const idTab = itemSelected.id

        this.props.pushNavHistory({
            section: this.props.sectionId,
            activeLetterFilter,
            activeCategoryTab,
            letterFilterPerTab
        })

        this.setState({ activeLetterFilter: idTab }, () => {
            this.fetchFilterCountries(idTab)
        })

        // Métricas
        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTabLabel = activeCategoryTab
        const childTabData = visibleLetterTabs.find(letter => letter.id === idTab)
        const childTabLabel = childTabData && childTabData.label
        sendMetricSelectContent(mainMenuLabel, parentTabLabel, childTabLabel)
    }

    onClickFavorite = (countryId, favorited) => {
        this.setState((prevState) => {
            const index = prevState.allCountries.findIndex(country => country.id === countryId)
            if (index === -1) return null
            
            const updatedCountries = [...prevState.allCountries]
            updatedCountries[index] = { ...updatedCountries[index], favorited }
            
            // Si estamos en la pestaña de favoritos, filtrar solo los que siguen siendo favoritos
            let updatedFiltered
            if (prevState.activeCategoryTab === this.idTabFavoritos) {
                updatedFiltered = updatedCountries.filter(country => country.favorited)
            } else {
                // En otras pestañas, solo actualizar el estado del país modificado
                const filteredIndex = prevState.filteredCountries.findIndex(country => country.id === countryId)
                updatedFiltered = filteredIndex !== -1
                    ? prevState.filteredCountries.map(country => 
                        country.id === countryId ? { ...country, favorited } : country
                      )
                    : prevState.filteredCountries
            }
            
            return { 
                allCountries: updatedCountries,
                filteredCountries: updatedFiltered
            }
        })
    }

    render() {
        const { activeLetterFilter, activeCategoryTab, visibleLetterTabs, filteredCountries } = this.state
        const {tabsFirstLevel} = this

        const mainMenuTabData = MAIN_MENU.find(item => item.id === this.props.sectionId) || null
        const mainMenuLabel = mainMenuTabData && Translator.get(mainMenuTabData.title)
        const parentTab = tabsFirstLevel.find(tab => tab.id === activeCategoryTab)
        const parentTabLabel = parentTab && parentTab.label
        const childTab = visibleLetterTabs.find(tab => tab.id === activeLetterFilter)
        const childTabLabel = activeCategoryTab === this.idTabFavoritos ? null : childTab && childTab.label

        return (
            <div>
                <div className='container-categories' ref={el => { this.categoryNavRef = el }}>
                    <Submenu 
                        tabs={tabsFirstLevel}
                        activeTab={activeCategoryTab}
                        onNavigate={this.onChangeTab}
                        classNames={{
                            tab: 'filter-item',
                            active: 'filter-item--active',
                        }}
                    />
                </div>

            <div className={`paises${this.props.headerHidden ? ' paises-height-without-brandheader' : ' paises-height-with-brandheader'}`}>
                    
                    <div
                        className='container-filters'
                        ref={el => { this.letterNavRef = el }}
                        onKeyDown={e => {
                            const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null
                            if (currentKey === 'UP') {
                                e.preventDefault()
                                e.stopPropagation()
                                e.nativeEvent && e.nativeEvent.stopImmediatePropagation()
                                const btn = this.categoryNavRef && this.categoryNavRef.querySelector('.focusable')
                                btn && btn.focus()
                            }
                        }}
                    >
                        <Submenu 
                            tabs={visibleLetterTabs}
                            activeTab={activeLetterFilter}
                            onNavigate={this.onChangeFilter}
                            classNames={{
                            tab: 'pais-item',
                            active: 'pais-item--active',
                        }}
                        />
                    </div>
                

                    <div className={`card-container`} ref={el => { this.containerRef = el }}>
                        {filteredCountries && filteredCountries.length === 0 && activeCategoryTab === this.idTabFavoritos
                            ? <EmptyFavorites />
                            : filteredCountries && filteredCountries.map((pais, index) => (
                                <CountryCard 
                                    key={index} {...pais} 
                                    onClickFavorite={this.onClickFavorite} 
                                    mainMenuLabel={mainMenuLabel}
                                    parentTabLabel={parentTabLabel}
                                    childTabLabel={childTabLabel}
                                />
                            ))
                        }
                    </div>

                </div>
            </div> 
        )
    }
}

const mapStateToProps = function (state) {
  return {
    headerHidden: state.headerHidden,
    pendingRestore: state.pendingRestore
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    pushNavHistory: function (entry) { dispatch(pushNavHistory(entry)) },
    restoreComplete: function () { dispatch(restoreComplete()) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Countries)


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/index.jsx